import React from "react";
import { useTranslation } from "react-i18next";

//Material-UI Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

//Custom components
import DialogToolbarMenuItem from "UI/Dialog/DialogToolbarMenuItem";

const DialogToolbarMenuItemActivate = React.forwardRef((props, ref) => {
  const { t } = useTranslation();

  return <DialogToolbarMenuItem label={t("buttons.activate")} icon={<CheckCircleIcon />} {...props} ref={ref} />;
});

export default DialogToolbarMenuItemActivate;
